import './styles/app.scss';
import React from 'react';
import ReactDOM from 'react-dom';

import NexRouter from './pages/router';
import './locales/i18n';

ReactDOM.render(<NexRouter />, document.getElementById('root'));
